import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

import {
  ProductionOrderIdentifier,
  TaskType,
} from '@compumark/analyst-selection-tool-client';
@Component({
  selector: 'app-details',
  standalone: false,
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent {
  protected isCopyrightTitleTask = false;
  protected taskId?: string;
  protected taskType!: string;
  protected productionOrderIdentifier?: ProductionOrderIdentifier;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.isCopyrightTitleTask =
      params.data.taskType === TaskType.TITLE ||
      params.data.taskType === TaskType.COPYRIGHT;
    this.taskId = params.data.id;
    this.taskType = params.data.taskType;
    this.productionOrderIdentifier = {
      productionOrderNumber: params.data.productionOrderIdentifier.prodOrderNo,
      productionOrderSequenceNumber:
        params.data.productionOrderIdentifier.prodOrderSeqNo,
    };
  }
}
